import Vue from 'vue';
import { Permission } from '@auth/interfaces/permission';
import { Center } from '@core/interfaces/tenant-state';
import router from '@app/router/index.APP_TARGET';
import AuthorizationHelper from '@auth/services/authorization.helper';
import store from '@app/store';

export default class AuthorizationService extends Vue {
  //
  // NOTE: The order is important to get the first available
  adminHomePageRoutes = [
    'admin-booking-events-daily',
    'admin-booking-events',
    'admin-enrollments',
    'admin-contacts',
    'admin-calendar',
    'admin-activities',
  ];

  // NOTE: The order is important to get the first available

  profileHomePageRoutes = [
    'contact-profile-dashboard',
    'profile-contact',
    'profile-mailbox',
    'profile-bookings',
    'profile-new-booking',
    'profile-new-organization-booking',
    'profile-enrollments',
    'profile-subscriptions',
    'profile-invoices',
    'profile-activities',
    'profile-family',
  ];

  hasPermissions(permissions: (string | Permission)[]) {
    // return true;
    const permission = permissions.find(permission => {
      return this.hasPermission(permission);
    });
    return !!permission;
  }
  hasPermission(permission: string | Permission): boolean {
    const name = typeof permission === 'string' ? permission : permission.name;
    const userPermissions = this.$authService.getPermissions();
    if (userPermissions && userPermissions.indexOf(name) > -1) {
      return true;
    }
    return false;
  }
  hasRole(roleName: string): boolean {
    const roles = this.$authService.getRoles();
    let hasRole = false;
    if (roles) {
      roles.forEach(role => {
        if (role.name === roleName && role.main) {
          hasRole = true;
        }
      });
    }
    return hasRole;
  }
  getContactId(): number {
    const roles = this.$authService.getRoles();
    let contactId = null;
    roles.forEach(role => {
      if (role.main) {
        contactId = role.contact_id;
      }
    });
    return contactId;
  }

  verifyRoute(routeName: string, params: Record<string, string>) {
    if (!routeName) {
      return false;
    }

    const link = router.resolve({
      name: routeName,
      params: params,
    });
    let hasPermission = true;
    let hasModuleActivated = true;
    let exists = false;

    if (link && link.href !== '/') {
      exists = true;
    }

    if (!exists) {
      return false;
    }

    const permissions = link.route?.meta?.permissions;
    if (permissions) {
      hasPermission = this.hasPermissions(permissions);
    }

    const mod = link?.route?.meta?.module;
    if (mod) {
      hasModuleActivated = this.$modulesService.hasModuleActivated(mod);
    }
    return exists && hasPermission && hasModuleActivated;
  }

  getTenantHomePage(tenant: Center) {
    const alias = tenant ? tenant.alias : 't';
    const homePage = tenant?.center_setting?.home_page;
    const params = { tenantAlias: alias };
    return {
      name: this.verifyRoute(homePage, params)
        ? homePage
        : this.getFirstAvailableAdminHomePageName(tenant),

      params: params,
    };
  }

  getFirstAvailableAdminHomePageName(tenant: Center): string {
    const alias = tenant ? tenant.alias : 't';
    const params = { tenantAlias: alias };

    const verifiedRouteName = this.adminHomePageRoutes.find(routeName => {
      return this.verifyRoute(routeName, params);
    });
    if (verifiedRouteName) {
      return verifiedRouteName;
    } else {
      const loginRoute = this.getAuthLoginRoute();
      router.push(loginRoute);
    }
  }

  getFirstAvailableProfileHomePageName(tenant: Center): string {
    const alias = tenant ? tenant.alias : 't';
    const params = { tenantAlias: alias };

    const verifiedRouteName = this.profileHomePageRoutes.find(routeName => {
      return this.verifyRoute(routeName, params);
    });

    if (verifiedRouteName) {
      return verifiedRouteName;
    } else {
      const loginRoute = this.getAuthLoginRoute();
      router.push(loginRoute);
    }
  }

  getTenantProfileHomePage(tenant: Center) {
    const alias = tenant ? tenant.alias : 't';
    const contactProfileHomePage = tenant?.center_setting?.contact_profile_home_page;
    const params = { tenantAlias: alias };
    return {
      name: this.verifyRoute(contactProfileHomePage, params)
        ? contactProfileHomePage
        : this.getFirstAvailableProfileHomePageName(tenant),
      params: params,
    };
  }

  getRedirectToHomePage(to: any = null) {
    if (this.hasPermission('access_to_admin_panel')) {
      const tenant = this.$authService.getSelectedTenant();

      return this.getTenantHomePage(tenant);
    } else if (this.hasPermission('access_to_profile_panel')) {
      const tenant = this.$authService.getSelectedTenant();
      return this.getTenantProfileHomePage(tenant);
      /* } else if (this.hasRole('public')) { */
    } else {
      const loginRoute = this.getAuthLoginRoute(to);
      return loginRoute;
    }
  }

  hasPermissionForAction(permissionEntityName: string, action: string, own: boolean = false) {
    const permission = AuthorizationHelper.getPermissionName(
      action,
      permissionEntityName.replace('-', '_'),
      own,
    );

    return this.hasPermission(permission);
  }

  getAuthLoginRoute(redirectAfterLogin = null) {
    let query = {};
    if (redirectAfterLogin && redirectAfterLogin.fullPath != '/') {
      query = { redirect: redirectAfterLogin.fullPath };
    }
    const selectedTenant = store.getters['tenant/selectedTenant'];
    const alias = selectedTenant?.alias;
    // TODO check this; i am not sure if
    // we have to redirect always to the login page
    const loginRoute = alias
      ? { name: 'auth-tenant-login', params: { tenantAlias: alias }, query: query }
      : { name: 'auth-tenant-login', query: query };
    return loginRoute;
  }
}
